import * as React from 'react';
import { useContext } from 'react';
import { PageProgress, updatePageProgress } from '../../../../../api/TourSignup';
import { PropertyContext } from '../TourRouter';
import * as moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { prospectPath, prospectPages } from '../../ProspectRouter';
import { Prospect } from '../../../../../api/Prospect';
import { HelpEmailLink } from '../../../../common/HelpLinks';
import { atcb_init } from 'add-to-calendar-button';
// import AddToCalendar from 'react-add-to-calendar';

interface Props {
    prospect: Prospect;
}

const SignupSuccessfulSubpage = (props: Props) => {

    React.useEffect(atcb_init, []);

    if (props.prospect.publicKey) {
        updatePageProgress(props.prospect.publicKey, PageProgress.TourScheduleSuccess);
    }

    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    function getTimeZone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    const name = `Tour24 - ${props.prospect.propertyName}`;
    let desc = `You have a self-guided tour scheduled at ${props.prospect.propertyName}.\n\n[br][br]Please download the Tour24 app before arriving.\n\n[br][br][url]https://apps.apple.com/gb/app/tour-24-self-guided-apt-tour/id1462185580|Download Tour24 from the App Store[/url]\n\n[br][br][url]https://play.google.com/store/apps/details?id=com.toursphere.tour24|Download Tour24 from Google Play[/url]\n\n[br][br]Access to the property is only valid during your scheduled time.\n\n[br][br]Tap [url]https://app.tour24now.com/prospect/login|Sign In [/url] / My Tours to start your Tour.\n Use the same phone number and password you used to register for your account.\n\n[br][br]Need to Reschedule? [url]https://app.tour24now.com/prospect/login|Sign In[/url] to your Tour24 account and go to the My Tours page.`;
    const startDate = props.prospect.tourInfo.event ? moment.tz(props.prospect.tourInfo.event.startDateTime, `${getTimeZone()}`).format('YYYY-MM-DD') : '';
    const endDate = props.prospect.tourInfo.event ? moment.tz(props.prospect.tourInfo.event.endDateTime, `${getTimeZone()}`).format('YYYY-MM-DD') : '';
    const startTime = props.prospect.tourInfo.event ? moment.tz(props.prospect.tourInfo.event.startDateTime, `${getTimeZone()}`).format('HH:mm') : '';
    const endTime = props.prospect.tourInfo.event ? moment.tz(props.prospect.tourInfo.event.endDateTime, `${getTimeZone()}`).format('HH:mm') : '';
    const timeZone = getTimeZone();
    const location = property.city + ',' + property.state;

    return (
        <div>
            <div>
                <p className="margin-top pb-2">
                    {props.prospect.contactInfo.firstName}, you are all set! Your tour of{' '}
                    {property.name} is confirmed for:
                </p>
                {props.prospect.tourInfo.event && (
                    <p className="success-timeslot pb-2">
                        <div>
                        {
                            `${moment(props.prospect.tourInfo.event.startDateTime).format(
                                'dddd, MMMM D'
                            )}`
                        } 
                        </div>
                        <div>
                        {
                            `${moment(props.prospect.tourInfo.event.startDateTime).format(
                                'h:mm A'
                            )} to ${moment(props.prospect.tourInfo.event.endDateTime).format(
                                'h:mm A'
                            )}`
                        }
                        </div>
                        
                    </p>
                )}
            </div>
            <div>
                <p>
                    You will receive an email with all of your tour details. (Please check your spam
                    filter for emails from{' '}
                    <a className="email-links" href="mailto:support@tour24now.com">
                        support@tour24now.com
                    </a>
                    .)
                </p>
                <p>
                    
                    <div className="atcb-wrapper">
                    Don't miss your tour appointment. Add this event to your personal Calendar
                        <div className="atcb">                                    
                            { '{' }
                                "name":"{name}",
                                "description":"{desc}",
                                "startDate": "{startDate}",
                                "endDate":"{endDate}",
                                "startTime":"{startTime}",
                                "endTime":"{endTime}",
                                "location":"{location}",
                                "label":"Add to calendar",
                                "options":[
                                "Apple",
                                "Google",
                                "iCal",
                                "Microsoft365",
                                "Outlook.com",
                                "Yahoo"
                                ],
                                "timeZone":"{timeZone}",
                                "iCalFileName":"Reminder-Event",
                                "trigger":"click",
                                "customLabels":"true"
                            { '}' }                    
                        </div>
                    </div>
                </p>
                <p>
                    If you have any questions, please contact <HelpEmailLink />.
                </p>
            </div>
            {/* <p>
                Following CDC recommendations, we encourage you to wear a face mask during your
                tour.
            </p> */}
            <p>Thanks for using Tour24!</p>
            <div>
                <Link
                    className="btn btn-primary font-weight-bold mb-4"
                    to={prospectPath(prospectPages.tours)}
                >
                    My Tours
                </Link>
            </div>
        </div>
    );
};

export default SignupSuccessfulSubpage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/SignupSuccessfulSubpage.tsx